/* eslint-disable */
import md5 from 'crypto-js/md5';
import encUtf8 from 'crypto-js/enc-utf8';
import encHex from 'crypto-js/enc-hex';

export function generateLegacyMarketingHash(emailValue) {
  const Base64Binary = {
    _keyStr:
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',

    /* will return a  Uint8Array type */
    decodeArrayBuffer(input) {
      const bytes = (input.length / 4) * 3;
      const ab = new ArrayBuffer(bytes);
      this.decode(input, ab);

      return ab;
    },

    removePaddingChars(input) {
      const lkey = this._keyStr.indexOf(input.charAt(input.length - 1));
      if (lkey === 64) {
        return input.substring(0, input.length - 1);
      }
      return input;
    },

    decode(input, arrayBuffer) {
      // get last chars to see if are valid
      input = this.removePaddingChars(input);
      input = this.removePaddingChars(input);

      const bytes = parseInt((input.length / 4) * 3, 10);

      let uarray;
      let chr1;
      let chr2;
      let chr3;
      let enc1;
      let enc2;
      let enc3;
      let enc4;
      let i = 0;
      let j = 0;

      if (arrayBuffer) uarray = new Uint8Array(arrayBuffer);
      else uarray = new Uint8Array(bytes);
      // eslint-disable-next-line
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

      for (i = 0; i < bytes; i += 3) {
        // get the 3 octects in 4 ascii chars
        enc1 = this._keyStr.indexOf(input.charAt(j++));
        enc2 = this._keyStr.indexOf(input.charAt(j++));
        enc3 = this._keyStr.indexOf(input.charAt(j++));
        enc4 = this._keyStr.indexOf(input.charAt(j++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        uarray[i] = chr1;
        if (enc3 != 64) uarray[i + 1] = chr2;
        if (enc4 != 64) uarray[i + 2] = chr3;
      }

      return uarray;
    },
  };

  function convertUint8ArrayToWordArray(u8Array) {
    const words = [];
    let i = 0;
    const len = u8Array.length;

    while (i < len) {
      words.push(
        (u8Array[i++] << 24) |
          (u8Array[i++] << 16) |
          (u8Array[i++] << 8) |
          u8Array[i++],
      );
    }

    return {
      sigBytes: words.length * 4,
      words,
    };
  }

  function hexToBase64(hexstring) {
    return btoa(
      hexstring
        .match(/\w{2}/g)
        .map(function (a) {
          return String.fromCharCode(parseInt(a, 16));
        })
        .join(''),
    );
  }

  function decodeUtf8(s) {
    return decodeURIComponent(escape(s));
  }

  function convertUint8ArrayToBinaryString(u8Array) {
    let i;
    const len = u8Array.length;
    let b_str = '';
    for (i = 0; i < len; i++) {
      b_str += u8Array[i].toString(2).padStart(8, 0);
    }
    return b_str;
  }

  function generate_legacy_hash(hashString) {
    let hex_hash = hashString.slice(0, 8);
    hex_hash += '-';
    hex_hash += hashString.slice(8, 12);
    hex_hash += '-';
    const version = '3';
    hex_hash += version;
    hex_hash += hashString.slice(13, 16);
    hex_hash += '-';
    const variant_bin = parseInt(hashString[16], 16)
      .toString(2)
      .padStart(4, '0');
    const rfc_variant_bin = `10${variant_bin.slice(2, 4)}`;
    const rfc_variant_hex = parseInt(rfc_variant_bin, 2).toString(16);
    hex_hash += rfc_variant_hex;
    hex_hash += hashString.slice(17, 20);
    hex_hash += '-';
    hex_hash += hashString.slice(20, 32);
    return hex_hash;
  }

  const email = emailValue;

  if (email) {
    const email_lower = email.toString().toLowerCase();
    const encoded_email = encUtf8.parse(email_lower);

    const h1 = md5(encoded_email).toString(encHex);
    const h1_utf8 = decodeUtf8(hexToBase64(h1));
    const h1_b64 = Base64Binary.decode(h1_utf8);
    const h1_word_array = convertUint8ArrayToWordArray(h1_b64);

    const h2 = md5(h1_word_array).toString(encHex);
    const hashed_email = generate_legacy_hash(h2);
    return hashed_email;
  }
  return null;
}
